import { Documento } from './documento.model';

export interface Posizione {
  chiuso: boolean;
  classificaId?: number | null;
  dataApertura: Date;
  dataChiusura?: Date | null;
  dataScadenza?: Date | null;
  descrizione?: string | null;
  paroleChiaveJson?: string | null;
  posizioneId: string;
  posizioneFisica?: string | null;
  progressivo?: number | null;
  sigla: string;
  tipologiaFascicolo?: string | null;
  orderString?: string;
  title?: string;

  documento?: Documento[];
  documentoCopiaPer?: Documento[];
  evidenza?: number;
  fasc?: string;
  firma?: number;
  note?: string | null;
  trattazione?: number;
  visione?: number;
  posTot?: string;
}


export const POSIZIONE_ROOT = "/";
